import { debounceTime, switchMap, takeUntil, skip } from 'rxjs/operators';

const autocomplete = (time: number, selector: any) => (source$: any) =>
  source$.pipe(
    debounceTime(time),
    switchMap((...args) =>
      selector(...args).pipe(takeUntil(source$.pipe(skip(1)))),
    ),
  );

export default autocomplete;
